jQuery(function($) {
    if ($('.accordion').length === 0) return;

    // Initialize: show content, icons, and aria-expanded for items with 'active' class
    $('.accordion__item').each(function() {
        var $item = $(this);
        var $header = $item.find('.accordion__header');
        var $content = $item.find('.accordion__content');
        var $plusIcon = $item.find('.accordion__icon--plus');
        var $minusIcon = $item.find('.accordion__icon--minus');

        if ($item.hasClass('active')) {
            $content.show();
            $plusIcon.hide();
            $minusIcon.show();
            $header.attr('aria-expanded', 'true');
        } else {
            $content.hide();
            $plusIcon.show();
            $minusIcon.hide();
            $header.attr('aria-expanded', 'false');
        }
    });

    // Click handler
    $('.accordion__header').on('click', function() {
        var $header = $(this);
        var $item = $header.closest('.accordion__item');
        var $content = $item.find('.accordion__content');
        var $plusIcon = $header.find('.accordion__icon--plus');
        var $minusIcon = $header.find('.accordion__icon--minus');

        var isActive = $item.hasClass('active');

        if (isActive) {
            // Close this item
            $item.removeClass('active');
            $content.slideUp(200);
            $plusIcon.show();
            $minusIcon.hide();
            $header.attr('aria-expanded', 'false');
        } else {
            // Open this item
            $item.addClass('active');
            $content.slideDown(200);
            $plusIcon.hide();
            $minusIcon.show();
            $header.attr('aria-expanded', 'true');
        }
    });
});
